import { useEffect, useState } from "react";
import { collection, doc, onSnapshot } from "firebase/firestore";
import { SalesSettingsSchema, paths, type SalesSettings } from "@clevis/shared-types";
import { db } from "../lib/firebase";

// Estimate types and terms, invoice terms, commission rules (Estimates → Types & terms).
export function useSalesSettings(tenantId: string | null): SalesSettings {
  const [settings, setSettings] = useState<SalesSettings>(() => SalesSettingsSchema.parse({}));
  useEffect(() => {
    if (!tenantId) return;
    return onSnapshot(
      doc(db, paths.tenantSalesSettings(tenantId)),
      (snap) => setSettings(SalesSettingsSchema.parse(snap.data() ?? {})),
      () => undefined,
    );
  }, [tenantId]);
  return settings;
}

export interface TeamMember {
  uid: string;
  name: string;
  role: string;
}

/** Active members, by name: who can own a sale. */
export function useTeamMembers(tenantId: string | null): TeamMember[] {
  const [members, setMembers] = useState<TeamMember[]>([]);
  useEffect(() => {
    if (!tenantId) return;
    return onSnapshot(collection(db, paths.tenantMembers(tenantId)), (snap) =>
      setMembers(
        snap.docs
          .filter((d) => d.get("disabled") !== true)
          .map((d) => ({ uid: d.id, name: (d.get("displayName") as string) || (d.get("email") as string) || "Teammate", role: (d.get("role") as string) ?? "" }))
          .sort((a, b) => a.name.localeCompare(b.name)),
      ),
    );
  }, [tenantId]);
  return members;
}

export const money = (c: number) => `$${(c / 100).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
